/**
 * Thin Axios wrapper around the backend REST API.
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const client = axios.create({ baseURL: `${API_URL}/api` });

/**
 * Upload a video file, reporting progress via onUploadProgress.
 * @param {File} file
 * @param {Function} onProgress - (percent:number) => void
 */
export function uploadVideo(file, onProgress) {
  const formData = new FormData();
  formData.append('video', file);

  return client.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) {
        onProgress(Math.round((evt.loaded * 100) / evt.total));
      }
    },
  });
}

export function startAnalysis(jobId) {
  return client.post('/analyze', { jobId });
}

export function getStatus(jobId) {
  return client.get(`/status/${jobId}`);
}

export function getResults(jobId) {
  return client.get(`/results/${jobId}`);
}

export function deleteJob(jobId) {
  return client.delete(`/job/${jobId}`);
}

export function frameImageUrl(jobId, fileName) {
  return `${API_URL}/api/results/${jobId}/frame/${fileName}`;
}

export function videoStreamUrl(jobId) {
  return `${API_URL}/api/results/${jobId}/video`;
}

export { API_URL };
export default client;
